<style lang="scss" scoped>
.v-dialog__content {
  height: 100%;
}

.v-dialog:not(.v-dialog--fullscreen) {
  // height: 84% !important;
  max-height: 540px !important;
}

.swiper-slide {
  max-height: 580px;
}

.v-card {
  height: 97%;
  position: relative;
}

.close {
  position: absolute;
  top: 0;
  right: 20px;
  color: #fff;
  margin: 0 !important;
  padding-top: 12px !important;
  font-size: 16px !important;
}

.float-right {
  margin-bottom: 30px;
}

.notice-pop {
  margin: 0 12px !important;
  box-shadow: none !important;
  overflow: hidden !important;

  .notice-content {
    max-height: 560px;
    padding-bottom: 10px;

    .swiper-container {
      .notice-content-text {
        max-height: 420px;
        min-height: 400px;
      }
    }

    .noticeSwiperPagination {
      bottom: 0px;
      width: 100% !important;
      text-align: center;

      .swiper-pagination-bullet-active {
        opacity: 0.6;
        background: #000;
      }
    }

    .v-responsive__content {
      font-size: 14px;
      line-height: 2;

      .notice-content-title {
        text-align: left;
        padding: 4px 15px;
        font-size: 16px;
      }

      .notice-content-text {
        padding: 0 15px;
        overflow-y: scroll;
        text-align: left;
      }
    }

    .notice-content-title {
      text-align: left;
      padding: 4px 15px;
      font-size: 16px;
    }

    .notice-content-text {
      padding: 0 15px;
      overflow: scroll;
      overflow-x: hidden !important;

      .str {
        max-height: 420px;
      }
    }
  }

  .notice-close {
    text-align: center;

    .notice-close-icon {
      font-size: 28px;
      color: #fff;
    }
  }
}
</style>
<style>
.v-dialog {
  text-align: initial !important;
}
</style>
<template>
  <!-- 弹窗公告 -->
  <v-dialog
    v-model="showNoticePopupModal"
    :content-class="showNoticePopupModal ? 'notice-pop showAnima' : 'notice-pop'"
    :eager="true"
  >
    <v-card>
      <img ref="image" style="width: 100%;max-height:50px" :src="popBanner" />

      <i class="close iconfont guanbi1" @click="$store.commit('message/setshowNoticeModal', false)"></i>

      <div class="notice-content">
        <swiper ref="noticeSwiper" :options="noticeSwiperOption" @slideChangeTransitionStart="tabSwiperChange()">
          <swiper-slide v-for="(item, index) in noticePopupList" :key="index">
            <template>
              <div class="notice-content-title">{{ item.noticeTitle }}</div>
              <div class="notice-content-text">
                <div class="str">
                  <div
                    v-if="item.isLoadHtmlText"
                    :id="`htmlEditor${index}`"
                    v-html="
                      item.isEnableFuTextMobile != 0 ? item.noticeFuTextMobile || item.noticeFuText : item.noticeFuText
                    "
                  ></div>
                </div>
              </div>
              <div v-if="showNoticePopupCreatTime == 1" class="float-right mr-3">{{ item.creationTime }}</div>
            </template>
          </swiper-slide>
          <div class="swiper-pagination noticeSwiperPagination" slot="pagination"></div>
        </swiper>
      </div>
    </v-card>
    <!-- <div class="notice-close" @click="$store.commit('message/setshowNoticeModal', false)">
      <i class="iconfont notice-close-icon">&#xe641;</i>
    </div> -->
  </v-dialog>
</template>
<script>
import appConfigMixins from '@c/mixins/appConfig.mixins'
import { ApigetNoticePopup } from '@/api/service.js'
export default {
  mixins: [appConfigMixins],
  data: function() {
    return {
      showNoticePopupModal: false,
      noticePopupList: [],
      noticeSwiperOption: {
        loop: true,
        pagination: {
          el: '.noticeSwiperPagination'
          // dynamicBullets: true
        }
      },
      wrapperHeight: 0
    }
  },
  watch: {
    showNoticePopup(value) {
      this.showNoticePopupModal = value
    },
    showNoticePopupModal(value) {
      if (!value) {
        this.$store.commit('message/setshowNoticeModal', false)
      }
    }
  },
  computed: {
    showNoticePopupCreatTime() {
      let flag = 1
      try {
        flag = this._config.notice_config.configValue.showNoticePopupCreatTime
        flag = flag == undefined ? 1 : flag
      } catch (e) {}
      return flag
    },
    showNoticePopup() {
      return this.$store.getters['message/showNoticeModal'] && this.noticePopupList.length > 0
    },
    indexTemp() {
      try {
        return this._config.app_config.configValue.template.index || 'default1'
      } catch (e) {
        return 'default1'
      }
    },

    _cdn() {
      return this.$store.getters['app/cdn']
    },
    popupTopbarBackgroundApp() {
      let flag = null
      try {
        flag = this._config.notice_config.configValue.popupTopbarBackgroundApp
      } catch (e) {}
      return flag
    },

    popBanner() {
      if (this.popupTopbarBackgroundApp) {
        return `${this._cdn}/${this.popupTopbarBackgroundApp}`
      } else {
        if (this.indexTemp == 'newyaboLottery' || this.indexTemp == 'ob') {
          return require('@/static/pages/home/yc01/notice.jpg')
        } else if (this.indexTemp == 'YongLi') {
          return require('@/static/pages/home/yc01/notice-yl.jpg')
        } else {
          return require('@/static/pages/home/notice_bar@2x.png')
        }
      }
    }
  },
  mounted() {
    this.$store.commit('message/setshowNoticeModal', false) //先关闭
    this.getNoticePopup()
  },
  methods: {
    tabSwiperChange() {
      const swiper = this.$refs.noticeSwiper.swiper
      let currentTabIndex = swiper.realIndex
      this.noticePopupList.forEach((item, index) => {
        item.isLoadHtmlText = index == currentTabIndex
      })
      //   this.noticePopupList[currentTabIndex].isLoadHtmlText = true
      let idName = `#htmlEditor${currentTabIndex}`
      this.$nextTick(() => {
        window.uParse(idName, {
          rootPath: this._cdn + '/pc/common/Ueditor/third-party'
        })
      })
    },
    getNoticePopup() {
      ApigetNoticePopup().then(res => {
        this.$store.dispatch('message/checkShowNotice', 1)
        if (res.code == '12200' && res.data.length) {
          res.data.map((item, index) => {
            if (index == 0) item.isLoadHtmlText = true
            else item.isLoadHtmlText = false
          })
          this.noticePopupList = res.data
          let idName = `#htmlEditor0`
          this.$nextTick(() => {
            window.uParse(idName, {
              rootPath: this._cdn + '/pc/common/Ueditor/third-party'
            })
          })
        }
      })
    }
  }
}
</script>
